import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_For_more_detailsX_visit_our_Xa_ELL,
  TXTWCL_If_you_have_any_questions_or_w_ELL,
  TXTWCL_You_may_still_withdraw_any_rem_ELL
} from './HelpSectionNationalExclusion.messages.json';

const HelpSectionNationalExclusion: React.FC = () => (
  <>
    <Translation {...TXTWCL_You_may_still_withdraw_any_rem_ELL} />{' '}
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.ContactSupport}>{msg}</ResolverLink>
        )
      }}
      {...TXTWCL_If_you_have_any_questions_or_w_ELL}
    />{' '}
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.AccountCloseBlockRestrict}>{msg}</ResolverLink>
        )
      }}
      {...TXTWCL_For_more_detailsX_visit_our_Xa_ELL}
    />
  </>
);

export default HelpSectionNationalExclusion;
